import React from "react"
import styles from "./Card.module.css"

const Card = ({ children, className, testId }) => {
  return (
    <div className={`${styles.container} ${className}`} data-testid={testId || "card"}>
      {children}
    </div>
  )
}

export default Card
